"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomBoardOption = void 0;
var RandomBoardOption;
(function (RandomBoardOption) {
    RandomBoardOption["OFFICIAL"] = "random official";
    RandomBoardOption["ALL"] = "random all";
})(RandomBoardOption || (exports.RandomBoardOption = RandomBoardOption = {}));
